<template>
	<ContentPlaceholders :rounded="rounded" :centered="true">
		<ContentPlaceholdersHeading v-if="heading" />
		<ContentPlaceholdersImg class="calendar-skeleton-image" />
	</ContentPlaceholders>
</template>

<script>
	export default {
		props: {
			rounded: { type: Boolean, default: false },
			heading: { type: Boolean, default: true },
		},
	}
</script>
<style lang="scss">
	.vue-content-placeholders-is-animated::v-deep .vue-content-placeholders-img::before {
		-webkit-animation-duration: 3s;
		animation-duration: 3s;
	}
</style>
